import React from 'react';
import HeaderTwo from "../components/header/HeaderTwo";
import { Link } from 'react-router-dom';
import FooterTwo from "../components/footer/FooterTwo";
import Breadcrumb from "./Breadcrumb";

function ContactUs() {
    const breadcrumbs = [
        { label: 'Home', link: '/' },
        { label: 'Contato' }
    ];

    return (
        <div>
            <HeaderTwo />

            <Breadcrumb title="Contato" breadcrumbs={breadcrumbs} />

            {/* contact single area start */}
            <div className="rts-contact-area rts-section-gap">
                <div className="container">
                    <div className="row g-5">

                        {/* TELEFONE / WHATSAPP */}
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="single-contact-one-inner">
                                <div className="thumbnail">
                                    {/* Ajustado: /assets/... */}
                                    <img src="/assets/images/contact/01.png" alt="WhatsApp GB Partner" />
                                </div>
                                <div className="content">
                                    <div className="icone">
                                        <img src="/assets/images/contact/shape/01.svg" alt="" />
                                    </div>
                                    <div className="info">
                                        <span>WhatsApp Especializado</span>
                                        <Link to={'https://wa.me/5571991810262'} target="_blank">
                                            <h5>(71) 99181-0262</h5>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* E-MAIL */}
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="single-contact-one-inner">
                                <div className="thumbnail">
                                    <img src="/assets/images/contact/02.png" alt="E-mail GB Partner" />
                                </div>
                                <div className="content">
                                    <div className="icone">
                                        <img src="/assets/images/contact/shape/02.svg" alt="" />
                                    </div>
                                    <div className="info">
                                        <span>Envie um e-mail</span>
                                        <Link to={'mailto:contato@gbpartner.com.br'}>
                                            <h5>contato@gbpartner.com.br</h5>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* ENDEREÇO */}
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div className="single-contact-one-inner">
                                <div className="thumbnail">
                                    <img src="/assets/images/contact/03.png" alt="Endereço GB Partner" />
                                </div>
                                <div className="content">
                                    <div className="icone">
                                        <img src="/assets/images/contact/shape/03.svg" alt="" />
                                    </div>
                                    <div className="info">
                                        <span>Nosso Escritório</span>
                                        <h5>
                                            Av. Antônio Carlos Magalhães, 1034 - 2º andar - Itaigara, Salvador - BA, 41825-906 
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* MAPA */}
            <div className="rts-contact-map-area">
                <div className="contaciner-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="contact-map-area-fluid">
                                <iframe
                                    className="contact-map"
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.896681014316!2d-38.4552467!3d-12.9784381!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x716037f3f1e582d%3A0x6b10705f9350410!2sSalvador%20-%20BA!5e0!3m2!1spt-BR!2sbr!4v1714856000000"
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                />
                                <img
                                    className="location"
                                    src="/assets/images/contact/shape/location.svg"
                                    alt="Localização"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* FORMULÁRIO */}
            <div className="rts-contact-form-area">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="rts-contact-fluid rts-section-gap">

                                <div className="rts-title-area contact-fluid text-center mb--50">
                                    <p className="pre-title">Fale Conosco</p>
                                    <h2 className="title">Precisa de apoio estratégico? Envie sua mensagem</h2>
                                </div>

                                <div className="form-wrapper">
                                    <form id="contact-form">
                                        <div className="name-email">
                                            <input type="text" name="name" placeholder="Seu nome" required />
                                            <input type="email" name="email" placeholder="Seu e-mail" required />
                                        </div>

                                        <input type="text" name="name" placeholder="Assunto" />

                                        <textarea
                                            name="message"
                                            placeholder="Como a GB Partner pode ajudar o seu negócio?"
                                        />

                                        <button type="submit" className="rts-btn btn-primary">
                                            Enviar Mensagem
                                        </button>
                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <FooterTwo />
        </div>
    );
}

export default ContactUs;